import axios from 'axios';
import { $authHost } from '.';

export function getClubs(user_token?: string) {
  return $authHost.request({
    url: '/clubs',
    ...(user_token && { headers: { usertoken: user_token } }),
  });
}

export async function setTrainers(idClub: string, user_token: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/appointment_trainers_duty`, {
      params: {
        club_id: idClub,
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: user_token,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function setServices(idClub: string, user_token: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/appointment_services_duty`, {
      params: {
        club_id: idClub,
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: user_token,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function setDates(idClub: string, user_token: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/appointment_dates`, {
      params: {
        club_id: idClub,
        end_date: new Date(new Date().setMonth(new Date().getMonth() + 1))
          .toISOString()
          .split('T')[0],
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: user_token,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function setSlots(idClub: string, user_token: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/appointment_times_duty`, {
      params: {
        club_id: idClub,
        end_date: new Date(new Date().setMonth(new Date().getMonth() + 1))
          .toISOString()
          .split('T')[0],
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: user_token,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function getSlots(idClub: string, user_token: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/appointment_times_duty`, {
      params: {
        club_id: idClub,
        end_date: new Date(new Date().setMonth(new Date().getMonth() + 1))
          .toISOString()
          .split('T')[0],
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: user_token,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function postAppointment(
  date_time: string,
  service_id: string,
  id_trener: string,
  room_id: string,
  idClub: string,
  user_token: string,
) {
  const response = await axios.post(
    `${import.meta.env.VITE_API_URL}/appointment`,
    {
      date_time: date_time,
      service_id: service_id,
      employee_id: id_trener,
      room_id: room_id,
      club_id: idClub,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: user_token,
      },
    },
  );
  return response;
}

export async function getClubInfo(idBranch: string) {
  const response = await axios.get(
    `${import.meta.env.VITE_API_CLUB_INFO_URL}:get?filter=${encodeURIComponent(
      JSON.stringify({ id_1c: idBranch }),
    )}&appends=cabinet_posts`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${import.meta.env.VITE_AUTHORISATION_CLUB_INFO}`,
      },
    },
  );
  return response.data;
}
